<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card v-if="!isCallbackRequestCompleted">
        <v-card-title primary-title>
          <v-container pa-0>
            <v-layout class="close_button">
              <v-btn
                size="1"
                icon
                @click="closeDialog()"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <v-layout justify-center>
              <div>
                <h3 class="headline mb-1 font-weight-light text-xs-center">
                  {{ supportlink ? $t("message.Callback.support") : $t("message.Callback.callbackMessage") }}
                </h3>
                <div v-if="!supportlink" class="body-1 text-xs-center grey--text lighten-1">
                  {{ $t("message.Callback.contactMessage") }}
                </div>
              </div>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text>
          <div v-if="supportlink" class="body-1 text-xs-center grey--text ligten-1">
            {{ $t("message.Callback.pleaseContactUsAt") }} <span v-html="supportlink" />
          </div>
          <v-flex
            offset-md2
            md8
            offset-sm1
            sm10
            xs12
            v-else
          >
            <v-layout align-center>
              <v-flex shrink px-1>
                <v-icon
                  :color="
                    errors.has('countryCode') || errors.has('phoneNumber')
                      ? 'red'
                      : null
                  "
                >
                  $vuetify.icons.phone_outline
                </v-icon>
              </v-flex>
              <v-flex xs2 px-1>
                <v-text-field
                  type="tel"
                  :label="$t('message.phone')"
                  v-model="countryCode"
                  class="allow-error-overflow"
                  name="countryCode"
                  placeholder="+1"
                  v-validate="{ required: true, regex: /^\+?\d{1,3}$/ }"
                  data-vv-as="country code"
                  @focus="clearErrorByField($event, 'countryCode')"
                  :error="errors.has('countryCode')"
                  :error-messages="
                    errors.has('countryCode') && errors.has('phoneNumber')
                      ? errors.first('phoneNumber')
                      : errors.first('countryCode')
                  "
                />
              </v-flex>
              <v-flex xs10 px-1>
                <v-text-field
                  type="tel"
                  v-model="phoneNumber"
                  name="phoneNumber"
                  class="allow-error-overflow"
                  v-validate="'required|max:15'"
                  data-vv-as="phone number"
                  @focus="clearErrorByField($event, 'phoneNumber')"
                  :error="errors.has('phoneNumber')"
                  :error-messages="
                    errors.has('countryCode') && errors.has('phoneNumber')
                      ? null
                      : errors.first('phoneNumber')
                  "
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-layout justify-center>
            <v-btn
              v-if="supportlink"
              depressed
              class="callback-btn"
              @click="closeDialog()"
            >
              {{ $t("message.Callback.close") }}
            </v-btn>
            <v-btn
              v-else
              depressed
              color="primary"
              class="callback-btn"
              @click="submitRequest()"
              :loading="loading"
            >
              {{ $t("message.submit") }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title primary-title>
          <v-container pa-0>
            <v-layout justify-center>
              <div>
                <h3 class="headline mb-1 font-weight-light text-xs-center">
                  {{ $t("message.Callback.thanks") }}
                </h3>
              </div>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-layout justify-center>
            <div>
              <h3 class="body-1 mb-1 font-weight-light text-xs-center">
                {{ $t("message.Callback.callbackSuccess") }}
              </h3>
              <div
                class="caption font-weight-light text-xs-center grey--text lighten-1"
              >
                {{ $t("message.Callback.callbackSuccessCaption") }}
              </div>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-layout justify-center>
            <v-btn
              depressed
              outline
              color="grey"
              class="callback-btn"
              @click="closeDialog()"
            >
              <span class="black--text">
                {{ $t("message.close") }}
              </span>
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import {
  VContainer,
  VLayout,
  VCardTitle,
  VBtn,
  VCard,
  VDialog,
  VCardActions,
  VCardText,
  VFlex,
  VTextField,
  VIcon
} from 'vuetify/lib';
import { AppService } from 'AppServices/appService';
const { placeCallbackRequest, editUserInformation } = new AppService();
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      countryCode: '',
      phoneNumber: '',
      dialog: false,
      isCallbackRequestCompleted: false,
      phone: '',
      loading: false
    };
  },
  components: {
    VContainer,
    VLayout,
    VBtn,
    VCard,
    VDialog,
    VCardActions,
    VCardText,
    VCardTitle,
    VFlex,
    VTextField,
    VIcon
  },
  computed: {
    ...mapGetters(['businessProfileId', 'user'])
  },
  props: {
    supportlink: {
      type: String,
      default: null
    }
  },
  methods: {
    ...mapActions(['setUser']),
    async submitRequest() {
      let isValid = await this.$validator.validate();
      if (isValid) {
        this.loading = true;
        let number = `${this.countryCode}-${this.phoneNumber}`;
        let userTemp = this.user;
        try {
          if (this.user && !this.user.phoneNumber) {
            userTemp.phoneNumber = number;
            this.setUser(userTemp);
            var patchData = [{ 'Name': 'phoneNumber', 'Value': number }]
            await editUserInformation(this.user.id, patchData);
          }
          let userid = this.user ? this.user.id : null;
          await placeCallbackRequest(userid, number, this.businessProfileId);
          this.isCallbackRequestCompleted = true;
        } finally {
          this.loading = false;
        }
      }
    },
    updateState() {
      this.dialog = !this.dialog;
      this.prefill();
    },
    clearErrorByField(_, fieldName) {
      this.errors.remove(fieldName);
    },
    closeDialog() {
      this.dialog = false;
      this.prefill();
      setTimeout(() => {
        this.isCallbackRequestCompleted = false;
      }, 1000);
    },
    prefill() {
      if (this.user && this.user.phoneNumber) {
        this.phone = this.user.phoneNumber.split('-');
        this.countryCode = this.phone[0];
        var number = this.phone[1];
        for(var i = 2; i < this.phone.length;i++)
        {
          number = number + '-' + this.phone[i];
        }
        this.phoneNumber = number;
      } else {
        this.clearErrorByField(null, 'phoneNumber');
        this.clearErrorByField(null, 'countryCode');
        this.countryCode = '';
        this.phoneNumber = '';
      }
    }
  }
};
</script>
<style scoped>
::v-deep .v-messages__message {
  line-height: 1 !important;
}
::v-deep .v-input--has-state.error--text .v-label {
  animation: none;
}

::v-deep .v-input .v-label {
  overflow: visible;
  white-space: nowrap;
}
.input-group.input-group--error label {
  animation: none !important;
}
.callback-btn {
  width: 69%;
}
</style>
<style lang="scss">
.close_button {
  position: absolute;
  top: 0px;
  right: 0px;
}
.allow-error-overflow {
  .v-text-field__details {
    white-space: nowrap;
    overflow: visible;
  }
}
</style>
